import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';

type HeaderTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type NativeHeaderProps = JSX.IntrinsicElements['h1'];

interface Props {
  tag: HeaderTag;
  content: string;
  customHtml: string;
  id?: NativeHeaderProps['id'];
  dataTestId?: string;
}

export type HeaderProps = StyledProps<Props>;

function Header(props: HeaderProps) {
  const { tag, content, customHtml, id, dataTestId } = props;
  const Type = tag;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return customHtml ? (
    <Type
      id={id}
      className={`fr-${tag} ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: customHtml }}
      data-testid={dataTestId}
    />
  ) : (
    <Type id={id} className={`fr-${tag} ${className}`} style={style} data-testid={dataTestId}>
      {content}
    </Type>
  );
}

Header.defaultProps = {
  tag: 'h2',
  content: '',
  customHtml: '',
};

Header.componentName = 'Header';

export default Header;
